import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import {
  Alert, Button, Link,
  DrawerBody, DrawerFooter
} from '@one-thd/sui-atomic-components';
import { AddToContext } from '../../AddToContext';

export const CopyProjectMessagingScreen = ({ selectedProject, copyProjectItems }) => {
  const {
    handleClose,
    showSuccessMessage,
    setShowSuccessMessage
  } = useContext(AddToContext);
  const isMultipleItems = copyProjectItems?.length > 1;

  const successMessage = () => {
    return (
      <div className="sui-flex sui-items-center">
        {isMultipleItems ? 'Items' : 'Item'} successfully added to&nbsp;
        <Link href={`/projects/${selectedProject?.projectId}`} className="sui-text-sm sui-underline">
          {selectedProject?.projectName}
        </Link>
      </div>
    );
  };

  return (
    <>
      <DrawerBody overflow="scroll">
        {showSuccessMessage && (
          <Alert
            status="success"
            onClose={() => setShowSuccessMessage(false)}
            data-testid="add-to-success-alert"
          >
            {successMessage()}
          </Alert>
        )}
        {!showSuccessMessage && (
          <Alert
            status="error"
            onClose={handleClose}
            data-testid="add-to-error-alert"
          >
            Unable to add item. Please try again.
          </Alert>
        )}
      </DrawerBody>
      <DrawerFooter position="center">
        <Button
          data-testid="add-to-ok-button"
          variant="primary"
          fullWidth
          onClick={handleClose}
          type="submit"
        > OK
        </Button>
      </DrawerFooter>
    </>
  );
};

CopyProjectMessagingScreen.propTypes = {
  selectedProject: PropTypes.shape({
    projectId: PropTypes.string,
    projectName: PropTypes.string
  }),
  copyProjectItems: PropTypes.arrayOf(PropTypes.string)
};

CopyProjectMessagingScreen.defaultProps = {
  selectedProject: {},
  copyProjectItems: []
};